import { gql, useMutation } from '@apollo/client';
import { REFETCH_USER_VIEWS } from './useUserViews';

export const UPDATE_USER_VIEW_MUTATION = gql`
  mutation UpdateUserView($viewId: String!, $viewInput: CreateViewInput!) {
    updateUserView(viewId: $viewId, viewInput: $viewInput) {
      base64Embedding
      createdAt
      lastModified
      userEmail
      viewId
      viewName
      appName
    }
  }
`;

export const useUpdateUserView = () => {
  const [updateUserView, state] = useMutation(UPDATE_USER_VIEW_MUTATION, {
    refetchQueries: [REFETCH_USER_VIEWS],
  });

  return { updateUserView, ...state };
};
